import authInitializer from 'src/modules/auth/authInitializer'

const initalizers = [authInitializer]
export default initalizers
